// #region payment enum
export enum PaymentAccountType {
  Card = 0,
  Cash = 1,
  EMV = 2,
  External = 3,
  PayButton = 4,
  PayPal = 5,
}

export enum PayGreenStatus {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  UNKNOWN = 'Unknown',
}
// #endregion

// #region restaurant vouchers (payGreen) types
export interface UserSavedRestaurantVouchers {
  AcceptedRestaurantVouchers: AcceptedRestaurantVoucher[];
  SavedUserRestaurantVouchers: SavedRestaurantVoucher[];
  StoreId: number;
  UserId: number;
}

export interface AcceptedRestaurantVoucher {
  Description: string;
  PaymentAccountType: number;
  VoucherBrand: string;
  VoucherScheme: string;
}

export interface SavedRestaurantVoucher {
  AvailableBalance: number;
  CreatedAt: string;
  Description: string;
  PaymentAccountId: number;
  PaymentAccountType: string;
  Status: PayGreenStatus;
  VoucherBrand: string;
  VoucherScheme: string;
}

export interface AddUserPayGreenVoucher {
  PaymentAccountId: number;
  UrlToRedirectTo: string;
}

export interface CategorizedMenuItemsResponse {
  CategorizedMenuItems: CategorizedMenuItems;
}

export interface CategorizedMenuItems {
  CanApplyRestaurantVoucher: number[];
  CanNotApplyRestaurantVoucher: number[];
}

export interface GetUserSavedRestaurantVouchersQueryParams {
  storeId: number; // prId
}

export interface GetUserSavedRestaurantVoucherStatusQueryParams {
  paymentAccountId: number;
  storeId: number; // prId
}

export interface PostAddUserPayGreenVoucherRequestPayload {
  payGreenVoucherScheme: string;
  storeId: number; // prId
}

export interface PostCategorizeMenuitemsRequestPayload {
  MenuItemIds: number[];
}

// #endregion
